/**
 * The mutation that resets the state of a store to the initial state passed.
 * @param useInitialState
 * @returns {(function(*): (*))|*}
 */
const resetState = (useInitialState) => (state) => {
  // If the initial state is a function, call it and assign the result to the state.
  if (typeof useInitialState === "function") {
    return Object.assign(state, useInitialState());
  }
  // If the initial state is an object, assign it to the state.
  return Object.assign(state, useInitialState || {});
};

/**
 * Checks if the from route has stores that need to be reset on navigation, and if so, resets them.
 * @param to
 * @param from
 */
const handleStoreCleanupOnNavigation = (to, from) => {
  if (from.meta?.storesToReset && from.meta?.storesToReset?.length) {
    from.meta.storesToReset.forEach((storeName) => {
      const vm = window.main;
      if (!vm.$store.hasModule(storeName)) {
        // eslint-disable-next-line no-console
        console.error("Module", storeName, "is not registered in the store, and thus cannot be reset.");
        return;
      }
      vm.$store.commit(`${storeName}/resetState`);
    });
  }
};
export { resetState, handleStoreCleanupOnNavigation };
